<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const vehicleTypeOptions = [
        `Voiture neuve`,
        `Voiture d'occasion`,
        `Moto`,
        `Camion`,
        `Véhicule utilitaire`,
        `Autre (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const brandOptions = [
        `Bajaj`,
        `BMW`,
        `Dacia`,
        `Ford`,
        `Harley-Davidson`,
        `Honda`,
        `Hyundai`,
        `Isuzu`,
        `Kia`,
        `Lamborghini`,
        `Lexus`,
        `Mercedes-Benz`,
        `Mitsubishi`,
        `Nissan`,
        `Peugeot`,
        `Renault`,
        `Suzuki`,
        `Toyota`,
        `Yamaha`,
        `Zongshen`,
        `Autre (précisez)`,
    ].map((v) => ({ label: v, value: v }));

    const budgetOptions = [
        `Moins de 5 000 000 FCFA`,
        `5 000 000 - 10 000 000 FCFA`,
        `10 000 000 - 20 000 000 FCFA`,
        `Plus de 20 000 000 FCFA`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const additionalServicesOptions = [
        `Entretien et réparation`,
        `Pièces détachées`,
        `Service après-vente`,
        `Contrat d'entretien`,
        `Location de véhicule`,
        `Autre (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.concessionnairesAutomobile.vehicleType}
        class=""
        let:field
        let:id
        label={`Quel type de véhicule recherchez-vous ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[350px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={vehicleTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.concessionnairesAutomobile.brand}
        class=""
        let:field
        let:id
        label={`Quelle marque de véhicule vous intéresse le plus ?`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={brandOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(brandOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.concessionnairesAutomobile.budget}
        class=""
        let:field
        let:id
        label={`Quel est votre budget approximatif pour l'achat d'un véhicule ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={budgetOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.concessionnairesAutomobile.additionalServices}
        class=""
        let:field
        let:id
        label={`Quels services supplémentaires vous intéressent ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={additionalServicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
